import Button from '@zenbusiness/common-components/Button';
import SharedAsset from '@zenbusiness/common-components/SharedAsset';
import Text from '@zenbusiness/common-components/Text';
import Title from '@zenbusiness/common-components/Title';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';

import superstyled, { superstyledWithRef } from '#client/pages/EducationStudio/utils/superstyled';

export const WorksheetContainer = superstyled({
  tag: Grid,
  styles: ({ theme }) => ({
    height: 'fit-content',
    width: '80%',
    marginLeft: 'auto',
    marginRight: 'auto',
    [theme.breakpoints.down('lg')]: {
      width: '90%'
    },
    [theme.breakpoints.down('md')]: {
      margin: '0 1rem',
      width: '100%'
    }
  })
});

export const GridItem = superstyled({
  tag: Grid,
  name: 'GridItem',
  slot: 'GridItem',
  styles: ({ theme }) => ({
    padding: theme.spacing(0),
    [theme.breakpoints.up('sm')]: {
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1)
    },
    [theme.breakpoints.up('md')]: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    },
    [theme.breakpoints.up('lg')]: {
      paddingLeft: theme.spacing(4),
      paddingRight: theme.spacing(4)
    }
  })
});

export const NextButton = superstyled({
  tag: Button,
  name: 'WorksheetNextButton',
  slot: 'WorksheetNextButton',
  styles: ({ theme }) => ({
    padding: '1.25rem 2rem',
    textTransform: 'none',
    marginBottom: '1rem',
    [theme.breakpoints.down('sm')]: {
      padding: '1.25rem 0',
      width: '100%'
    }
  })
});

export const DownloadButton = superstyled({
  tag: Button,
  name: 'DownloadButton',
  slot: 'DownloadButton',
  styles: {
    width: '100%',
    padding: '1rem 0',
    textTransform: 'none'
  }
});

export const ButtonRight = superstyled({
  tag: Button,
  name: 'ButtonRight',
  slot: 'ButtonRight',
  styles: {
    float: 'right'
  }
});

export const ResponsiveImage = superstyled({
  tag: SharedAsset,
  name: 'ResponsiveImage',
  slot: 'ResponsiveImage',
  styles: ({ theme }) => ({
    width: '100%',
    height: 'auto',
    maxWidth: '28.125rem',
    [theme.breakpoints.up('md')]: {
      maxWidth: '31.25rem'
    },
    borderStyle: 'solid',
    borderWidth: '1px 5px 5px 1px',
    borderRadius: '1rem'
  })
});

export const ImageContainer = superstyled({
  tag: Box,
  styles: {
    display: 'flex',
    justifyContent: 'center'
  }
});

// classes.title
export const StyledTitle = superstyled({
  tag: Title,
  styles: ({ theme }) => ({
    marginBottom: '1.5rem',
    [theme.breakpoints.down('sm')]: {
      marginBottom: '1rem'
    }
  })
});

export const List = superstyled({
  tag: 'ul',
  styles: {
    paddingLeft: '1.4rem',
    marginTop: '0.375rem'
  }
});

export const BottomSpacing = superstyled({
  tag: Box,
  styles: ({ theme }) => ({
    marginBottom: '2rem !important',
    [theme.breakpoints.down('sm')]: {
      marginBottom: '1.5rem !important'
    }
  })
});
export const TextWithBottomSpacing = superstyled({
  props: { size: 'lg' },
  tag: Text,
  styles: ({ theme }) => ({
    marginBottom: '2rem !important',
    [theme.breakpoints.down('sm')]: {
      marginBottom: '1.5rem !important'
    }
  })
});

export const UserInputSpacing = superstyled({
  tag: Text,
  styles: ({ theme }) => ({
    userInputSpacing: {
      marginBottom: '0.375rem !important',
      [theme.breakpoints.down('sm')]: {
        marginBottom: '1.5rem !important'
      }
    }
  })
});

export const SummaryCardContainer = superstyledWithRef({
  tag: Box,
  styles: ({ theme }) => ({
    marginLeft: 'auto',
    marginRight: 'auto',
    [theme.breakpoints.up('md')]: {
      maxWidth: '31.25rem'
    }
  })
});

export const SummaryCard = superstyled({
  tag: Box,
  propsNeeded: ['bgcolor'],
  styles: ({ theme, bgcolor }) => ({
    padding: '2rem',
    backgroundColor: theme.palette[bgcolor]?.main,
    [theme.breakpoints.down('sm')]: {
      padding: '1.5rem'
    }
  })
});

export const SummaryCardTitle = superstyled({
  tag: Title,
  styles: ({ theme }) => ({
    fontSize: '1.75rem',
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.25rem'
    }
  })
});

export const SummaryCardTextSpacing = superstyled({
  tag: Text,
  styles: {
    paddingBottom: '1.5rem'
  }
});

export const SummaryEmojiSpacing = superstyled({
  tag: Text,
  styles: {
    marginRight: '0.625rem'
  }
});

export const SummaryCardTwoColumns = superstyled({
  tag: Box,
  styles: ({ theme }) => ({
    width: '100%',
    margin: '0 auto',
    maxWidth: '65rem',
    display: 'grid',
    '& > div:last-of-type': {
      gridColumnStart: '-1',
      gridColumnEnd: '1'
    },
    [theme.breakpoints.up('md')]: {
      gridTemplateColumns: '1fr 1fr',
      columnGap: '2.5rem'
    }
  })
});
